import { useEffect, useMemo, useRef, useState } from "react";
import { assignFormValues } from "../../../Utils/Auth";
import {
  computeDisabledPanelIds,
  getConflictingPanelNameForCombination,
  getICDPanelsIndex,
  getSpecimenSourceIndex,
  hideIcdAndComorbidityForPanel,
  panelsArrItemAddChild,
  panelsArrItemRemoval,
  panelsArrItemRemovalChild,
  panelsArrMakerToSend,
} from "../../../Utils/Common/Requisition";
import useLang from "../../hooks/useLanguage";
import { useLocation } from "react-router-dom";

const MultipleHeaderSelectable = (props: any) => {
  const { t } = useLang();
  const [panelsArrToSend, setPanelsArrToSend] = useState<any>([]);
  const [mutualExclusivityError, setMutualExclusivityError] = useState<string>("");
  const location = useLocation()

  const currentPanels =
    props?.Inputs?.[props?.index]?.fields?.[props?.fieldIndex]?.panels ??
    props?.panels ??
    [];

  const panelSelectionKey = currentPanels
    .map((p: any) => `${p.panelID}:${p.isSelected}`)
    .join("|");

  const disabledPanelIds = useMemo(
    () => computeDisabledPanelIds(currentPanels, props?.panelCombinations),
    [props?.panelCombinations, panelSelectionKey]
  );

  const getConflictingPanelName = (panelID: string | number): string =>
    getConflictingPanelNameForCombination(
      panelID,
      props?.Inputs?.[props?.index]?.fields?.[props?.fieldIndex]?.panels ??
        props?.panels ??
        [],
      props?.panelCombinations
    );
  useEffect(() => {
    const {
      Inputs,
      index,
      fieldIndex,
      depControlIndex,
      isDependency,
      repeatFieldSection,
      isDependencyRepeatFields,
      repeatFieldIndex,
      repeatDependencySectionIndex,
      repeatDepFieldIndex,
      setInputs,
      infectiousData,
      ArrayReqId,
      setInfectiousData,
    } = props;

    const currentField = Inputs?.[index]?.fields?.[fieldIndex];
    let inputsCopy = JSON?.parse(JSON?.stringify(props?.Inputs));
    let specimenSourceIndex = getSpecimenSourceIndex(inputsCopy);

    if (!currentField?.panels || location.state?.reqId) return;

    const specimenInputs = specimenSourceIndex != null ? props?.Inputs[specimenSourceIndex]?.fields : null;

    currentField.panels.forEach((panel: any) => {
      if (!panel.isDefaultSelectOnRequisition) return;

      panel.isSelected = true;

      // Set visibility on matching specimenSources
      if (specimenInputs) {
        specimenInputs?.forEach((field: any) => {
          field?.specimenSources?.forEach((source: any) => {
            if (source?.panelName === panel.panelName) {
              source.isVisible = true;
              source.isSelected = true;
              source?.specimenSourceOption?.forEach((element: any) => {
                element.isSelected = true;
              });
            }
          });
        });
      }

      // Select all test options
      panel.testOptions?.forEach((option: any) => {
        option.isSelected = true;
      });
    });

    // Only the selected panels may go into `defaultValue`. Writing the full
    // `panels` list here left a non-empty value behind with nothing selected,
    // which silently satisfied the field's `min(1)` validation.
    const newInputsPromise = assignFormValues(
      Inputs,
      index,
      depControlIndex,
      fieldIndex,
      (currentField?.panels ?? []).filter((panel: any) => panel?.isSelected),
      isDependency,
      repeatFieldSection,
      isDependencyRepeatFields,
      repeatFieldIndex,
      repeatDependencySectionIndex,
      repeatDepFieldIndex,
      undefined,
      setInputs
    );

    newInputsPromise?.then((updatedSections) => {
      if (!updatedSections) return;

      const infectiousDataCopy = JSON.parse(JSON.stringify(infectiousData));
      const sectionIndex = FindIndex(infectiousData, ArrayReqId);

      if (sectionIndex !== -1) {
        infectiousDataCopy[sectionIndex].sections = updatedSections;
        setInfectiousData([...infectiousDataCopy]);
      }
    });
  }, [props?.IsSelectedByDefaultCompendiumData]);

  useEffect(() => {
    setpanelsArrToSendForEdit();
  }, [props.panels]);

  useEffect(() => {
    setMutualExclusivityError("");
  }, [panelSelectionKey]);

  function FindIndex(arr: any[], rid: any) {
    return arr.findIndex((i: any) => i.reqId === rid);
  }
  const handleChangeParent = (
    panelID: number,
    panelName: string,
    checked: boolean,
    index: number
  ) => {
    const livePanels =
      props?.Inputs?.[props?.index]?.fields?.[props?.fieldIndex]?.panels ??
      props?.panels ??
      [];
    const activeDisabledPanelIds = computeDisabledPanelIds(
      livePanels,
      props?.panelCombinations
    );

    // Block selection if this panel is mutually exclusive with an already-selected panel.
    // The user sees a friendly message instead of a silent no-op.
    if (checked && activeDisabledPanelIds.has(String(panelID))) {
      const conflictingName = getConflictingPanelNameForCombination(
        panelID,
        livePanels,
        props?.panelCombinations
      );
      setMutualExclusivityError(
        conflictingName
          ? `"${panelName}" cannot be selected because "${conflictingName}" is already selected. Only one panel can be selected from this group.`
          : "Only one panel can be selected from this group. Please deselect the current selection first."
      );
      return;
    }
    setMutualExclusivityError("");
    props.fields.enableRule = "";
    const name = panelName;
    let panelsArrToAppendCopy = [...panelsArrToSend];
    let inputsCopy = JSON?.parse(JSON?.stringify(props?.Inputs));
    if (checked) {
      let ICDPanelIndex = getICDPanelsIndex(props?.Inputs);
      let specimenSourceIndex = getSpecimenSourceIndex(inputsCopy);
      props.Inputs[props.index].fields[props?.fieldIndex].panels[
        index
      ].isSelected = true;
      props.Inputs[props.index].fields[props?.fieldIndex].panels[
        index
      ].testOptions.forEach((testOptions: any) => {
        testOptions.isSelected = true;
      });
      if (ICDPanelIndex) {
        props.Inputs[ICDPanelIndex]?.fields?.forEach((IcdPanelsFields: any) => {
          if (IcdPanelsFields.systemFieldName == "ICDPanels") {
            IcdPanelsFields?.panels?.forEach((panelsInfo: any) => {
              if (panelsInfo.panelName == name) {
                panelsInfo.isVisible = true;
              }
            });
          }
        });
      }
      if (specimenSourceIndex) {
        props?.Inputs[specimenSourceIndex]?.fields?.forEach(
          (specimenSourceFields: any) => {
            specimenSourceFields?.specimenSources?.forEach(
              (panelsInfo: any) => {
                if (panelsInfo?.panelName === name) {
                  panelsInfo.isVisible = true;
                }
              }
            );
          }
        );
      }
      let finalisedPanelsArrToSend = panelsArrMakerToSend(
        index,
        props?.Inputs[props.index]?.fields[props?.fieldIndex]?.panels[index],
        panelsArrToAppendCopy,
        checked
      );
      setPanelsArrToSend(finalisedPanelsArrToSend);
      let newInputs = assignFormValues(
        props?.Inputs,
        props?.index,
        props?.depControlIndex,
        props?.fieldIndex,
        finalisedPanelsArrToSend,
        props?.isDependency,
        props?.repeatFieldSection,
        props?.isDependencyRepeatFields,
        props?.repeatFieldIndex,
        props?.repeatDependencySectionIndex,
        props?.repeatDepFieldIndex,
        undefined,
        props?.setInputs
      );
      newInputs?.then((res) => {
        let infectiousDataCopy = JSON?.parse(
          JSON?.stringify(props?.infectiousData)
        );
        infectiousDataCopy[
          FindIndex(props?.infectiousData, props?.ArrayReqId)
        ].sections = res;
        props?.setInfectiousData([...infectiousDataCopy]);
      });
    }
    if (!checked) {
      // debugger;
      let specimenSourceIndex = getSpecimenSourceIndex(inputsCopy);
      // Hide the panel's ICD-10/comorbidity cards and also drop the codes the
      // user had already picked for it from the Diagnosis Code(s) list.
      hideIcdAndComorbidityForPanel(inputsCopy, name, panelID);
      if (specimenSourceIndex) {
        inputsCopy[specimenSourceIndex]?.fields?.forEach(
          (specimenSourceFields: any) => {
            specimenSourceFields?.specimenSources?.forEach(
              (panelsInfo: any) => {
                if (panelsInfo?.panelName === name) {
                  panelsInfo.isVisible = false;
                }
              }
            );
          }
        );
      }
      inputsCopy[props.index].fields[props?.fieldIndex].panels[
        index
      ].isSelected = false;
      inputsCopy[props.index].fields[props?.fieldIndex].panels[
        index
      ].testOptions.forEach((testOptions: any) => {
        testOptions.isSelected = false;
      });

      let finalisedPanelsArrToSend = panelsArrItemRemoval(
        panelID,
        panelsArrToAppendCopy
      );
      setPanelsArrToSend(finalisedPanelsArrToSend);
      let newInputs = assignFormValues(
        inputsCopy,
        props?.index,
        props?.depControlIndex,
        props?.fieldIndex,
        finalisedPanelsArrToSend,
        props?.isDependency,
        props?.repeatFieldSection,
        props?.isDependencyRepeatFields,
        props?.repeatFieldIndex,
        props?.repeatDependencySectionIndex,
        props?.repeatDepFieldIndex,
        undefined,
        props?.setInputs
      );
      newInputs?.then((res) => {
        let infectiousDataCopy = JSON?.parse(
          JSON?.stringify(props?.infectiousData)
        );
        infectiousDataCopy[
          FindIndex(props?.infectiousData, props?.ArrayReqId)
        ].sections = res;
        props?.setInfectiousData([...infectiousDataCopy]);
      });
    }
  };
  /**
   * The field's stored value must be the panels the user actually has selected.
   * Writing the append-only `storeChild` state left `defaultValue` non-empty
   * while nothing was selected, which is what let the required Testing Option
   * pass its `min(1)` check on a retry. `SelectablePanel` always wrote the
   * filtered list, which is why only `MultipleSelectablePanel` showed the bug.
   */
  const getSelectedPanels = (inputs: any) =>
    (inputs?.[props?.index]?.fields?.[props?.fieldIndex]?.panels ?? []).filter(
      (panel: any) => panel?.isSelected
    );

  const handleChangeChild = (
    testID: string,
    checked: boolean,
    parentPanelName: string,
    index: number,
    childIndex: number,
    panelID: any
  ) => {
    props.fields.enableRule = "";
    let inputsCopy = JSON.parse(JSON?.stringify(props?.Inputs));
    let panelsArrToAppendCopy = JSON.parse(JSON?.stringify(panelsArrToSend));
    let panelsCopy = [...props?.panels];
    let ICDPanelIndex = getICDPanelsIndex(inputsCopy);
    if (checked) {
      let specimenSourceIndex = getSpecimenSourceIndex(inputsCopy);
      props.Inputs[ICDPanelIndex]?.fields?.forEach((IcdPanelsFields: any) => {
        if (IcdPanelsFields.systemFieldName == "ICDPanels") {
          IcdPanelsFields?.panels?.forEach((panelsInfo: any) => {
            if (panelsInfo.panelName == parentPanelName) {
              panelsInfo.isVisible = true;
            }
          });
        }
      });
      if (specimenSourceIndex) {
        inputsCopy[specimenSourceIndex]?.fields?.forEach(
          (specimenSourceFields: any) => {
            specimenSourceFields?.specimenSources?.forEach(
              (panelsInfo: any) => {
                if (panelsInfo?.panelName === parentPanelName) {
                  panelsInfo.isVisible = true;
                }
              }
            );
          }
        );
      }
      // Update child checkbox state
      inputsCopy[props.index].fields[props?.fieldIndex].panels[
        index
      ].testOptions[childIndex].isSelected = true;
      // Update parent checkbox state
      inputsCopy[props.index].fields[props?.fieldIndex].panels[
        index
      ].isSelected = true;
      const currentPanel =
        inputsCopy[props.index].fields[props?.fieldIndex].panels[index];
      console.log(currentPanel, "currentPanel");
      const allChildUnchecked = inputsCopy[props.index].fields[
        props?.fieldIndex
      ].panels[index].testOptions.every((option: any) => !option.isSelected);
      // If all child checkboxes are unchecked, update parent checkbox state and panel visibility
      if (allChildUnchecked) {
        // Uncheck the parent checkbox
        inputsCopy[props.index].fields[props?.fieldIndex].panels[
          index
        ].isSelected = false;
        // Update parent panel visibility
      }

      let newInputs = assignFormValues(
        inputsCopy,
        // props?.dependenceyControls,
        props?.index,
        props?.depControlIndex,
        props?.fieldIndex,
        getSelectedPanels(inputsCopy),
        props?.isDependency,
        props?.repeatFieldSection,
        props?.isDependencyRepeatFields,
        props?.repeatFieldIndex,
        props?.repeatDependencySectionIndex,
        props?.repeatDepFieldIndex,
        undefined,
        props?.setInputs
      );
      newInputs?.then((res) => {
        let infectiousDataCopy = JSON?.parse(
          JSON?.stringify(props?.infectiousData)
        );
        infectiousDataCopy[
          FindIndex(props?.infectiousData, props?.ArrayReqId)
        ].sections = res;
        props?.setInfectiousData([...infectiousDataCopy]);
      });
    } else {
      let specimenSourceIndex = getSpecimenSourceIndex(inputsCopy);
      props.Inputs[ICDPanelIndex]?.fields?.forEach((IcdPanelsFields: any) => {
        if (IcdPanelsFields.systemFieldName == "ICDPanels") {
          IcdPanelsFields?.panels?.forEach((panelsInfo: any) => {
            if (panelsInfo.panelName == parentPanelName) {
              panelsInfo.isVisible = false;
            }
          });
        }
      });

      // Uncheck the child checkbox
      inputsCopy[props.index].fields[props?.fieldIndex].panels[
        index
      ].testOptions[childIndex].isSelected = false;
      // Check if all child checkboxes in the parent panel are unchecked
      const allChildUnchecked = inputsCopy[props.index].fields[
        props?.fieldIndex
      ].panels[index].testOptions.every((option: any) => !option.isSelected);
      // If all child checkboxes are unchecked, update parent checkbox state and panel visibility
      if (allChildUnchecked) {
        // Uncheck the parent checkbox
        inputsCopy[props.index].fields[props?.fieldIndex].panels[
          index
        ].isSelected = false;
        // The panel is now fully deselected, so its ICD-10/comorbidity codes
        // must not stay behind in the Diagnosis Code(s) list.
        hideIcdAndComorbidityForPanel(inputsCopy, parentPanelName, panelID);
        if (specimenSourceIndex) {
          inputsCopy[specimenSourceIndex]?.fields?.forEach(
            (specimenSourceFields: any) => {
              specimenSourceFields?.specimenSources?.forEach(
                (panelsInfo: any) => {
                  if (panelsInfo?.panelName === parentPanelName) {
                    panelsInfo.isVisible = false;
                  }
                }
              );
            }
          );
        }
      }

      let newInputs = assignFormValues(
        inputsCopy,
        // props?.dependenceyControls,
        props?.index,
        props?.depControlIndex,
        props?.fieldIndex,
        getSelectedPanels(inputsCopy),
        props?.isDependency,
        props?.repeatFieldSection,
        props?.isDependencyRepeatFields,
        props?.repeatFieldIndex,
        props?.repeatDependencySectionIndex,
        props?.repeatDepFieldIndex,
        undefined,
        props?.setInputs
      );
      newInputs?.then((res) => {
        let infectiousDataCopy = JSON?.parse(
          JSON?.stringify(props?.infectiousData)
        );
        infectiousDataCopy[
          FindIndex(props?.infectiousData, props?.ArrayReqId)
        ].sections = res;
        props?.setInfectiousData([...infectiousDataCopy]);
      });
    }
    // Update inputs and req states
  };

  const setpanelsArrToSendForEdit = () => {
    let panelsCopy = [...props?.panels];
    let filteredPanelsCopy = panelsCopy?.filter(
      (panelsData: any) => panelsData?.isSelected
    );
    let panelNameArr: any = [];
    filteredPanelsCopy?.forEach((panelData: any) => {
      panelNameArr?.push(panelData?.panelName);
    });
    let inputsCopy = [...props?.Inputs];
    // On edit the saved codes are restored into the Diagnosis Code(s) list, but
    // the ICD-10 cards of the already selected panels stay hidden. Reveal them
    // again so every code configured for those panels is available, not just
    // the one picked when the requisition was created.
    let ICDPanelIndex = getICDPanelsIndex(inputsCopy);
    if (ICDPanelIndex !== undefined && ICDPanelIndex !== null && ICDPanelIndex !== -1) {
      inputsCopy[ICDPanelIndex]?.fields?.forEach((IcdPanelsFields: any) => {
        if (IcdPanelsFields.systemFieldName == "ICDPanels") {
          IcdPanelsFields?.panels?.forEach((panelsInfo: any) => {
            if (panelNameArr?.includes(panelsInfo?.panelName)) {
              panelsInfo.isVisible = true;
            }
          });
        }
      });
    }
    assignFormValues(
      inputsCopy,
      // props?.dependenceyControls,
      props?.index,
      props?.depControlIndex,
      props?.fieldIndex,
      filteredPanelsCopy,
      props?.isDependency,
      props?.repeatFieldSection,
      props?.isDependencyRepeatFields,
      props?.repeatFieldIndex,
      props?.repeatDependencySectionIndex,
      props?.repeatDepFieldIndex,
      undefined,
      props?.setInputs
    );
    setPanelsArrToSend(filteredPanelsCopy);
  };
  const divElement = useRef<HTMLDivElement | null>(null); // Initialize ref for div
  useEffect(() => {
    // Scroll to the div if props.error is present
    if (props.error && divElement.current) {
      divElement.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
    props.setErrorFocussedInput && props.setErrorFocussedInput();
  }, [props?.errorFocussedInput]);
  return (
    <div ref={divElement}>
      {props.error && (
        <div className="form__error">
          <span>{t(props.error)}</span>
        </div>
      )}

      <div id={props?.name} ref={divElement} tabIndex={-1}></div>
      {/* Shown when a user tries to select a panel that is blocked by mutual exclusivity rules */}
      {mutualExclusivityError && (
        <div className="d-flex align-items-center gap-2 mb-3 text-muted" style={{ fontSize: "0.8rem" }}>
          <svg width="14" height="14" viewBox="0 0 16 16" fill="none" style={{ flexShrink: 0, color: "#f59e0b" }}>
            <circle cx="8" cy="8" r="7.5" stroke="currentColor"/>
            <path d="M8 5v3.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
            <circle cx="8" cy="11" r="0.75" fill="currentColor"/>
          </svg>
          <span style={{ color: "#92400e" }}>{mutualExclusivityError}</span>
        </div>
      )}
      {/* ArrayReqId 58: compact pill-only layout — hides test options, shows panel names only.
          Uses a custom SVG checkmark instead of a native checkbox for consistent styling. */}
      {props?.ArrayReqId === 58 ? (
        <div className="d-flex flex-column gap-2">
          {props?.panels?.map((options: any, index: number) => {
            if (!options.isVisible) return null;
            const isPanelDisabled = disabledPanelIds.has(String(options?.panelID));
            return (
              <label
                key={index}
                className={`d-flex align-items-center gap-2 px-4 py-2 border rounded ${
                  isPanelDisabled
                    ? "border-gray-200 text-muted"
                    : options?.isSelected
                    ? "border-primary bg-light-primary"
                    : "border-gray-300 bg-light"
                }`}
                style={{
                  cursor: isPanelDisabled ? "not-allowed" : "pointer",
                  opacity: isPanelDisabled ? 0.55 : 1,
                  userSelect: "none",
                  minWidth: "fit-content",
                }}
                onClick={(e: any) => {
                  if (isPanelDisabled) {
                    e.preventDefault();
                    const conflictingName = getConflictingPanelName(options?.panelID);
                    setMutualExclusivityError(
                      conflictingName
                        ? `"${options?.panelName}" cannot be selected because "${conflictingName}" is already selected. Only one panel can be selected from this group.`
                        : "Only one panel can be selected from this group. Please deselect the current selection first."
                    );
                  }
                }}
              >
                <input
                  type="checkbox"
                  className="d-none"
                  checked={options?.isSelected}
                  disabled={isPanelDisabled}
                  onChange={(e: any) => {
                    handleChangeParent(
                      options?.panelID,
                      options?.panelName,
                      e.target.checked,
                      index
                    );
                  }}
                />
                <span
                  className={`d-flex align-items-center justify-content-center rounded flex-shrink-0 ${
                    options?.isSelected ? "bg-primary border-primary" : "border border-gray-400 bg-white"
                  }`}
                  style={{ width: 18, height: 18 }}
                >
                  {options?.isSelected && (
                    <svg width="11" height="9" viewBox="0 0 11 9" fill="none">
                      <path d="M1 4L4 7L10 1" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  )}
                </span>
                <span className="fw-600">{options?.panelName}</span>
              </label>
            );
          })}
        </div>
      ) : (
        props?.panels?.map((options: any, index: number) => {
          const isPanelDisabled = disabledPanelIds.has(String(options?.panelID));
          return (
            <>
              {options.isVisible && (
                <div className={`${props?.displayType}`}>
                  <div className="row">
                    <div className="col-lg-12">
                      <div className={`card border ${isPanelDisabled ? "border-gray-200" : "border-gray-300"} mb-3 rounded`}
                        style={isPanelDisabled ? { opacity: 0.55 } : {}}>
                        <div
                          className="card-header bg-light d-flex justify-content-between align-items-center rounded min-h-35px px-4"
                          style={isPanelDisabled ? { cursor: "not-allowed" } : {}}
                          onClick={() => {
                            if (isPanelDisabled) {
                              const conflictingName = getConflictingPanelName(options?.panelID);
                              setMutualExclusivityError(
                                conflictingName
                                  ? `"${options?.panelName}" cannot be selected because "${conflictingName}" is already selected. Only one panel can be selected from this group.`
                                  : "Only one panel can be selected from this group. Please deselect the current selection first."
                              );
                            }
                          }}
                        >
                          <div className="col-12">
                            <label className="form-check form-check-sm form-check-solid col-12">
                              <input
                                className="form-check-input mr-2 h-20px w-20px"
                                type="checkbox"
                                checked={options?.isSelected}
                                disabled={isPanelDisabled}
                                onChange={(e: any) => {
                                  handleChangeParent(
                                    options?.panelID,
                                    options?.panelName,
                                    e.target.checked,
                                    index
                                  );
                                }}
                              />
                              {<span className="fw-600">{options?.panelName}</span>}
                            </label>
                          </div>
                        </div>
                        <div className="card-body py-md-4 py-3 col-12">
                          <div className="row">
                            {options?.testOptions?.map(
                              (optionsChild: any, childIndex: any) => (
                                <>
                                  <div
                                    className={
                                      options?.testOptions.length > 1
                                        ? "mb-3 col-xxl-3 col-xl-4 col-lg-4 col-md-6 col-sm-12"
                                        : "mb-3 col-xl-12 col-lg-12 col-md-12 col-sm-12"
                                    }
                                  >
                                    <label className="form-check form-check-sm align-items-start form-check-solid col-12">
                                      <input
                                        className="form-check-input mr-2 h-20px w-20px"
                                        type="checkbox"
                                        disabled={isPanelDisabled}
                                        onChange={(e: any) => {
                                          handleChangeChild(
                                            optionsChild?.testID,
                                            e?.target?.checked,
                                            options?.panelName,
                                            index,
                                            childIndex,
                                            options?.panelID
                                          );
                                        }}
                                        checked={optionsChild?.isSelected}
                                      />
                                      <div className="d-flex justify-content-between">
                                        <span className="fw-400">
                                          {optionsChild?.testName}
                                        </span>
                                        <span className="text-muted">
                                          {optionsChild?.specimenType}
                                        </span>
                                      </div>
                                    </label>
                                  </div>
                                </>
                              )
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </>
          );
        })
      )}
    </div>
  );
};

export { MultipleHeaderSelectable };
